module.exports = __webpack_public_path__ + "img/rammsv2.2bb0ed58.png";